module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.stepPreview.description_visibility) ? _c('h2', {
    staticClass: "kbx-description",
    style: (_vm.stepStyle('welcome-description')),
    attrs: {
      "klickbox-edit-item": "welcome-description",
      "klickbox-edit-label": _vm.$t('edit.canvas.welcome_description'),
      "klickbox-edit-label": "Descrição de Boas Vindas"
    }
  }, [_c('text-editor', {
    attrs: {
      "content": _vm.stepPreview.description_text,
      "change": _vm.onChange,
      "toolbar": true,
      "placeholder": _vm.$t('edit.canvas.welcome_description')
    }
  })], 1) : _vm._e()])
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-fad4d3e8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/edit/canvas/preview/step/welcome/Description.vue
 ** module id = 927
 ** module chunks = 1
 **/